import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { trackAddToCart } from "@/lib/pixels";

const CartContext = createContext(null);
const KEY = "drelo_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) {
        return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        product_id: product.id, title: product.title, price: product.price,
        image: product.image, quantity: qty,
      }];
    });
    trackAddToCart(product, qty);
    setOpen(true);
  }, []);

  const setQty = useCallback((id, qty) => {
    setItems((prev) => qty <= 0
      ? prev.filter((i) => i.product_id !== id)
      : prev.map((i) => i.product_id === id ? { ...i, quantity: qty } : i));
  }, []);

  const remove = useCallback((id) => setItems((prev) => prev.filter((i) => i.product_id !== id)), []);
  const clear = useCallback(() => setItems([]), []);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
